// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services {
  background: var(--bg-light);
}

.services__head {
  margin-bottom: 48px;
}

.services__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 26px;
}

.service-card {
  background: #fff;
  border-radius: var(--radius-lg);
  padding: 28px;
  border: 1px solid var(--border-soft);
  transition: transform 0.22s ease, box-shadow 0.22s ease;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-md);
}

.service-card__media {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 18px;
  box-shadow: var(--shadow-sm);
}

.service-card__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.service-card__tag-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.service-card__tag {
  display: inline-block;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--teal-dark);
  background: var(--teal-tint);
  padding: 4px 11px;
  border-radius: 100px;
}

.service-card h3 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.service-card p {
  font-size: 14px;
}

@media (max-width: 980px) {
  .services__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 620px) {
  .services__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Services.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".services {\n  background: var(--bg-light);\n}\n\n.services__head {\n  margin-bottom: 48px;\n}\n\n.services__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 26px;\n}\n\n.service-card {\n  background: #fff;\n  border-radius: var(--radius-lg);\n  padding: 28px;\n  border: 1px solid var(--border-soft);\n  transition: transform 0.22s ease, box-shadow 0.22s ease;\n}\n\n.service-card:hover {\n  transform: translateY(-8px);\n  box-shadow: var(--shadow-md);\n}\n\n.service-card__media {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-bottom: 18px;\n  box-shadow: var(--shadow-sm);\n}\n\n.service-card__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.service-card__tag-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.service-card__tag {\n  display: inline-block;\n  font-size: 11.5px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: var(--teal-dark);\n  background: var(--teal-tint);\n  padding: 4px 11px;\n  border-radius: 100px;\n}\n\n.service-card h3 {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.service-card p {\n  font-size: 14px;\n}\n\n@media (max-width: 980px) {\n  .services__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 620px) {\n  .services__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
